import { createUSeDirectBookingStrategy } from "./usedirect.js";

export default createUSeDirectBookingStrategy({
  bookingBaseUrl: "https://reservendparks.com/Web",
});
